import React from 'react'
import { useLocaleStore } from '../../Contexts/localeStore'
import translation from '../../../translations/menu.json'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import { BackButton, Dashboard, Parameters } from '../Common'

interface ParametersAndDashboardContainerProps {
  handleBack: () => void
  hideMenu: boolean
}

const ParametersAndDashboardContainer = ({
  handleBack,
  hideMenu = false
}: ParametersAndDashboardContainerProps): JSX.Element => {
  const { locale } = useLocaleStore()

  return (
    <div className='rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto'>
      {/* Back to conversation button */}
      <BackButton
        title={
          translation[locale]?.backconversation ||
          translation['fr-FR'].backconversation
        }
        className='rf-px-4 rf-text-sm'
        handleBack={handleBack}
      />

      <div className='rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden'>
        {/* Dashboard */}
        {!hideMenu && (
          <React.Fragment>
            <Dashboard toggleDashboard={handleBack} />
            <div className='rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder' />
          </React.Fragment>
        )}

        {/* Parameters container */}
        <div className='rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start'>
          {/* Title */}
          <div className='rf-py-4 rf-text-lightgray'>
            {capitalizeFirstLetter(
              translation[locale]?.parameters || translation['fr-FR'].parameters
            )}
          </div>

          {/* Parameters */}
          <Parameters handleBack={handleBack} />
        </div>
      </div>
    </div>
  )
}

export default ParametersAndDashboardContainer
